import React from "react";

interface QuestionTooltip {
  content: string[];
  title: string;
}

export const QuestionTooltip = ({
  questionTooltip
}: {
  questionTooltip?: QuestionTooltip;
}) => {
  return (
    <div className="ch-card">
      <div className="ch-pt--0 ch-pl--2 ch-pr--2 ch-pb--3">
        <div className="icon__help"></div>
        <h5 className="ch-fs--3 ch-mt--2 ch-mb--1">{questionTooltip?.title}</h5>
        {questionTooltip?.content && questionTooltip.content.length > 1 ? (
          <ul className="ch-list ch-measure ch-fs--2" data-testid="question-tooltip-content-ul">
            {questionTooltip.content.map((content, index) => (
              <li key={index}>{content}</li>
            ))}
          </ul>
        ) : (
          <p className="ch-fs--2" data-testid="question-tooltip-content-p">{questionTooltip?.content[0]}</p>
        )}
      </div>
    </div>
  );
};
